import JwtDecode from 'jwt-decode'
import moment from 'moment'

export default class User {
  static from (token) {
    try {
      let obj = JwtDecode(token)
      return new User(obj)
    } catch (_) {
      return null
    }
  }

  constructor ({ exp, iat, sub }) {
    this.exp = exp
    this.iat = iat
    this.sub = sub
  }

  get username () {
    return this.sub
  }

  get avatarFirstLetter () {
    return this.sub.charAt(0).toUpperCase()
  }

  get expISO () {
    return moment.unix(this.exp).toISOString()
  }
  get iatISO () {
    return moment.unix(this.iat).toISOString()
  }
}
